import { render, staticRenderFns } from "./Setsex.vue?vue&type=template&id=bd42ce48&scoped=true&"
import script from "./Setsex.vue?vue&type=script&lang=js&"
export * from "./Setsex.vue?vue&type=script&lang=js&"
import style0 from "./Setsex.vue?vue&type=style&index=0&id=bd42ce48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd42ce48",
  null
  
)

export default component.exports